module.exports = __webpack_public_path__ + "media/img/frond_end_agnets_card-01-01-1ff6ca03f7be7b477ef756b4104cadef.svg";